import {
  FETCH_PACKAGE_STATUS_LIST_PENDING,
  FETCH_PACKAGE_STATUS_LIST_REJECTED,
  FETCH_PACKAGE_STATUS_LIST_FULFILLED,
} from "../constants/packageStatuses";

const initialState = {
  pending: true, 
  packageStatuses: [],
  error: {},
};

export const packageStatuses = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PACKAGE_STATUS_LIST_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_PACKAGE_STATUS_LIST_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_PACKAGE_STATUS_LIST_FULFILLED:
      return {
        ...state,
        packageStatuses: action.response.results,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/packageStatuses.js